import {
  darkPalette,
  primaryColor,
  switchBaseUnCheckColor,
  buttonOutlineBorderColor,
} from "../palette";

export const MuiButton = {
  MuiButton: {
    root: {
      textTransform: "none",
    },
    outlined: {
      border: "1px solid",
      borderColor: buttonOutlineBorderColor,
      color: primaryColor,
      "&.Mui-disabled": {
        color: primaryColor,
        border: "1px solid",
        borderColor: primaryColor,
        opacity: ".25",
      },
    },
    contained: {
      "&.Mui-disabled": {
        backgroundColor: primaryColor,
        opacity: ".25",
        color: darkPalette.text.primary,
      },
    },
    label: {
      color: darkPalette.text.primary,
    },
  },
  MuiSwitch: {
    switchBase: {
      color: switchBaseUnCheckColor,
    },
  },
};
